import React from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import TicketForm from "./ticketComponents/TicketForm";

import { useCreateTicketMutation } from "store/services/ticketApi";

import { useAppMeta, useAuth } from "hooks";

const TicketCreateScreen = () => {
  const navigate = useNavigate();
  const { isVendor, isVendorStaff } = useAuth();

  const breadcrumbs = [
    { title: "Tickets", path: isVendor ? "/app/vendor/ticket/list" : isVendorStaff ? "/app/staff/ticket/list" : "/app/crm/ticket/list" },
    { title: "New Ticket" },
  ];

  // RTK Query
  const [createTicket, { isLoading: creatingTicket }] =
    useCreateTicketMutation();

  // methods
  const handleAddTicket = async (data) => {
    try {
      if (isVendor) {
        data = {
          ...data,
          dueDate: new Date(new Date().setDate(new Date().getDate() + 7)),
          stage: "Open",
        };
      }
      const { _id } = await createTicket(data).unwrap();
      toast.success("Ticket successfully created!");
      navigate(
        isVendor
          ? `/app/vendor/ticket/${_id}/detail`
          :
          isVendorStaff
            ? `/app/staff/ticket/${_id}/detail`
            : `/app/crm/ticket/${_id}/detail`
      );
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't create ticket!");
    }
  };

  useAppMeta("New Ticket");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingTicket}>
      <BreadcrumbLayout.Paper>
        <TicketForm onSubmit={handleAddTicket} isBusy={creatingTicket} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default TicketCreateScreen;
